import { createContext, useCallback, useEffect, useMemo, useState } from 'react'
import { getNotificationsSettings, saveNotificationsSettings } from '../services/notificationsSettings.service'

const NotificationsSettingsContext = createContext(null)

export const NotificationsSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const refetch = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const data = await getNotificationsSettings()
      setSettings(data)
    } catch (e) {
      setError(e?.message || 'Error cargando configuración de notificaciones')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    refetch()
  }, [refetch])

  const update = useCallback(async (nextSettings) => {
    await saveNotificationsSettings(nextSettings)
    setSettings(nextSettings)
  }, [])

  const value = useMemo(() => ({
    settings,
    loading,
    error,
    refetch,
    update
  }), [settings, loading, error, refetch, update])

  return (
    <NotificationsSettingsContext.Provider value={value}>
      {children}
    </NotificationsSettingsContext.Provider>
  )
}

export default NotificationsSettingsContext

